import { call, put, takeLatest } from 'redux-saga/effects'

import { fetchTutorialListApi } from 'containers/Tutorials/services'
import { fetchTutorialList } from './actions'
import { FETCH_TUTORIAL_LIST } from './constants'

function* fetchTutorialListWorker(action) {
  const response = yield call(fetchTutorialListApi, action.deviceId)

  if (response) {
    yield put(fetchTutorialList.success(response.tutorials))
  }
}

export default function* watcher() {
  yield takeLatest(FETCH_TUTORIAL_LIST.REQUEST, fetchTutorialListWorker)
}
